import css from './style.module.scss';
import classNames from "classnames";
import {FC} from "react";

type Props = {
    isMain: boolean
    onStart: () => void
}

const Footer: FC<Props> = ({
    isMain,
    onStart
}) => {
    const classes = classNames({
        [css.footer]: true,
        [css.main]: isMain,
    });

    return (
        <div className={classes}>
            <div className={css.bg}/>
            <div className={css.icon}>
                {
                    isMain ? (
                        <img src={"./images/logo.svg"} alt="logo"/>
                    ) : (
                        <img src={"./images/logo-dark.svg"} alt="logo"/>
                    )
                }

            </div>
            {
                isMain && (
                    <div className={css.btn} onClick={onStart}>
                        Play now
                    </div>
                )
            }
        </div>
    )
}

export default Footer;